import { ArrowRight } from '@phosphor-icons/react';

const scrollToForm = (e) => { e.preventDefault(); document.getElementById('hero')?.scrollIntoView({ behavior: 'smooth' }); };

export default function CTASection() {
  return (
    <section data-testid="cta-section" className="relative py-16 sm:py-20 lg:py-28 overflow-hidden bg-[#07c28e]">
      <div className="absolute inset-0 opacity-10" style={{ backgroundImage: `radial-gradient(circle at 25% 25%, rgba(0,0,0,0.15) 2px, transparent 2px)`, backgroundSize: '24px 24px' }} />
      <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center relative z-10">
        <h2 className="text-3xl sm:text-4xl lg:text-6xl font-extrabold text-[#191E29] tracking-tight leading-tight mb-6">
          Ready to Ship<br />at Velocity?
        </h2>
        <p className="text-lg text-[#191E29]/60 max-w-xl mx-auto mb-10">
          Join hundreds of businesses who trust us with their fulfillment. Let's scale your operations together.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a href="#hero" onClick={scrollToForm} data-testid="cta-bottom-primary" className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-[#191E29] text-white text-lg font-bold rounded-full hover:bg-[#0f1319] transition-colors shadow-xl">
            Schedule My Call <ArrowRight size={18} weight="bold" />
          </a>
          <a href="#hero" onClick={scrollToForm} data-testid="cta-bottom-secondary" className="inline-flex items-center justify-center px-8 py-4 border-2 border-[#191E29] text-[#191E29] text-lg font-bold rounded-full hover:bg-[#191E29]/10 transition-colors">
            Book a Free Audit
          </a>
        </div>
      </div>
    </section>
  );
}
